export const commonTranslationEN = {
  'Failed to get data': 'Failed to get data',
  'Yes': 'Yes',
  'No': 'No',
  'Add': 'Add',
  'Close': 'Close',
  'Cancel': 'Cancel',
  'Save': 'Save',
  'Delete': 'Delete',
  'Confirmation Message': 'Confirmation Message',
  'Individual Data Folders': 'Individual Data Folders',
  'Export': 'Export',
  'Failed to move folder': 'Failed to move folder',
  'New Folder': 'New Folder',
  'Delete Folder': 'Delete Folder',
  'Delete Format': 'Delete Format',
  'Load': 'Load',
  'There are not folders': 'There are not folders',
  'Format Name': 'Format Name',
  'Type': 'Type',
  'Field': 'Field',
  'Path': 'Path',
  'Direction': 'Direction',
  'Description': 'Description',
  'Name': 'Name',
  'dontSave': "Don't save",
  'Add Text': 'Add Text',
  'Save As': 'Save As',
  'Print': 'Print',
  'Undo': 'Undo',
  'Redo': 'Redo',
  'Copy': 'Copy',
  'Paste': 'Paste',
  'Select All': 'Select All',
  'Position': 'Position',
  'Alignment': 'Alignment',
  'Folders': 'Folders',
  'Fields': 'Fields',
  'Failed to get folders': 'Failed to get folders',
  'Failed to load folders': 'Failed to load folders',
  'Failed to load formats': 'Failed to load formats',
  'Failed to load format': 'Failed to load format',
  'Failed to check format name': 'Failed to check format name',
  'Failed to create folder': 'Failed to create folder',
  'There are no folders': 'There are no folders',
  'Please select the folder or search fields': 'Please select the folder or search fields',
  'Load Datasheet': 'Load Datasheet',
  'New Datasheet': 'New Datasheet',
  'Export Format': 'Export Format',
  'Load Format': 'Load Format',
  'Import Format': 'Import Format',
  'Failed to fetch folders': 'Failed to fetch folders',
  'Failed to fetch fields': 'Failed to fetch fields',
  'Individual': 'Individual',
  'Pedigree': 'Pedigree',
  'Table': 'Table',
  'Select': 'Select',
  'Folder': 'Folder',
  'Submit': 'Submit',
  'OK': 'OK',
  'Create': 'Create',
  'New Format': 'New Format',
  'Add Tab': 'Add Tab',
  'The folder {folderName} already exists. Please enter a different name': 'The folder {folderName} already exists. Please enter a different name',
  'Please select fields to run the spreadsheet': 'Please select fields to run the spreadsheet',
  'Rename Tab': 'Rename Tab',
  'Copy Tab': 'Copy Tab',
  'Paste Tab': 'Paste Tab',
  'Delete Tab': 'Delete Tab',
  'Loading': 'Loading',
  'Left': 'Left',
  'Center': 'Center',
  'Right': 'Right',
  'Bottom': 'Bottom',
  'Top': 'Top',
  'Saving': 'Saving',
  'None': 'None',
  'Save format': 'Save format',
  'Order': 'Order',
  'Field Type': 'Field Type',
  'Field Name': 'Field Name',
  'Failed to save format': 'Failed to save format',
  'Failed to check format name exists': 'Failed to check format name exists',
  'The format name already exists': 'The format name already exists',
  'Open': 'Open',
  'Failed to get formats': 'Failed to get formats',
  'No data': 'No data',
  'No folders': 'No folders',
  'Datasheet Format Folders': 'Datasheet Format Folders',
  'Failed to get pedigree members count': 'Failed to get pedigree members count',
  'Failed to get Fhq invite relatives': 'Failed to get Fhq invite relatives',
  'youCantInviteMembersToFamilyHistoryQuestionnaire': "You can't invite members of this family to Family History Questionnaire",
  'inOneOfPreviousStepsChooseIndividualQuestionnaire': 'In one of previous steps choose Individual Questionnaire or select Family that still has only one member',
  'Please fill all fields': 'Please fill all fields',
  'inviteEmailProblem': 'There is a problem with the email addresses for the selected individuals. Invitations were not sent to the following individuals:',
};